const token =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOiJDME5TMEwxRDNaX0FQUF9SRUFDVF9OQVRWRSIsImlhdCI6MTY2MDY3NDMxM30.p0D2GqNky9ZM-DkRtF0nEW9583nXvlxCSTI4QWp3Jr0';

export default token;
